import React, { useState } from "react";
import { filterFormFields, getFieldLabelByType } from "../../utils/Config/DefaultConfig/formFieldConfig";
import { getFieldIcon } from "../../utils/getFieldIcon";
import MaterialIcon from "../../components/BuilderComponents/MaterialIcon";

const RightSideFieldsBar = ({ onClick, from = "form", handleDragStart }) => {
  const [currentOption, setCurrentOption] = useState(1);
  const selectedFields = filterFormFields(from);

  const fieldGroup = (heading, fieldList) => {
    return (
      <>
        <label className="builder_label">{heading}</label>
        <div className="draggable_formField_rightPanel">
          {fieldList.map((type) => (
            <div
              key={type}
              onDragStart={(e) => handleDragStart && handleDragStart(e, type)}
              draggable={handleDragStart ? true : false}
              className="draggable_input_field"
              onClick={() => onClick && onClick(type)}
            >
              <MaterialIcon name={getFieldIcon(type)} />
              <span className="field_name">{getFieldLabelByType(type)}</span>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <>
      <div className="sidebar_tab_buttons  form_field">
        <div
          onClick={() => setCurrentOption(1)}
          className={currentOption === 1 ? "active sidebar_tabs" : "sidebar_tabs"}
        >
          Basic
        </div>
        <div
          onClick={() => setCurrentOption(2)}
          className={currentOption === 2 ? "active sidebar_tabs" : "sidebar_tabs"}
        >
          Advanced
        </div>
      </div>
      <div className="draggable_formField_rightPanel_outer">
        {currentOption === 1 && fieldGroup("Basic Fields", selectedFields.basicFields)}
        {currentOption === 2 && (
          <>
            {fieldGroup("Reference Fields", selectedFields.referenceFields)}
            {fieldGroup("Grouping Fields", selectedFields.groupingFields)}
            {fieldGroup("More Fields", selectedFields.moreFields)}
          </>
        )}
      </div>
    </>
  );
};

export default RightSideFieldsBar;
